import { cva } from 'class-variance-authority';

export const navigationMenuRootClasses =
  'relative z-10 flex max-w-max flex-1 items-center justify-center';

export const navigationMenuListClasses =
  'group flex flex-1 list-none items-center justify-center';

export const navigationMenuTriggerStyle = cva(
  'group inline-flex h-10 w-max items-center justify-center rounded-md bg-surface px-4 py-2 text-sm font-medium transition-colors hover:bg-background-secondary hover:text-text-primary focus:bg-background-secondary focus:text-text-primary focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-background-secondary/50 data-[state=open]:bg-background-secondary/50'
);

export const navigationMenuTriggerChevronClasses =
  'relative top-px ms-1 size-3 transition duration-200 group-data-[state=open]:rotate-180';

export const navigationMenuContentClasses =
  'start-0 top-0 w-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-end]:rtl:slide-in-from-left-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=from-start]:rtl:slide-in-from-right-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-end]:rtl:slide-out-to-left-52 data-[motion=to-start]:slide-out-to-left-52 data-[motion=to-start]:rtl:slide-out-to-right-52 md:absolute md:w-auto';

export const navigationMenuViewportContainerClasses =
  'absolute start-0 top-full flex justify-center';

export const navigationMenuViewportClasses =
  'relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-surface text-text-primary shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]';

export const navigationMenuIndicatorClasses =
  'top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in';

export const navigationMenuIndicatorDotClasses =
  'relative top-[60%] size-2 rotate-45 rounded-ss-sm bg-border shadow-md';

export const navigationMenuVerticalClasses = 'relative flex flex-1 flex-col';

export const sidebarPanelViewportContainerClasses = 'pointer-events-none fixed z-50';

export const sidebarPanelViewportTransitionSwitchingClasses =
  'transition-[inset-inline-start,top] duration-200 ease-out';

export const sidebarPanelViewportTransitionDefaultClasses =
  'transition-[inset-inline-start] duration-200 ease-out';

export const sidebarPanelViewportInnerClasses =
  'pointer-events-auto h-[var(--radix-navigation-menu-viewport-height)] w-[var(--radix-navigation-menu-viewport-width)] overflow-hidden rounded-lg border bg-surface-accent shadow-lg data-[state=closed]:opacity-0 data-[state=open]:opacity-100';

export const sidebarNavigationMenuContentClasses =
  'left-0 top-0 w-full md:absolute md:w-auto data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-bottom-4 data-[motion=from-start]:slide-in-from-top-4 data-[motion=to-end]:slide-out-to-bottom-4 data-[motion=to-start]:slide-out-to-top-4';
